import { GameInfoType } from '@/pages/opinion/operationLog/buriedPoint';
import { getOpinionFeedsReviewers } from '@/pages/opinion/services';
import { debounce } from 'lodash-es';
import { useMemo, useRef, useState } from 'react';

export default function useGetRequest({
  gameInfo,
  timeParams,
  params,
  singleKey = 'search_content',
  multipleKey = 'reviewers',
  requestFunc = getOpinionFeedsReviewers,
  hasMultiple = true,
  dealwithData = (data: any) => data,
  defaultLoading = false,
}: {
  gameInfo?: GameInfoType;
  timeParams?: { start_time: string; end_time: string; date_type: string };
  params: any;
  singleKey?: 'search_content' | 'steam_id_content' | 'keyword';
  multipleKey?: 'reviewers' | 'steam_ids';
  requestFunc?: (
    payload: any,
    cancelTokenFunc?: (cancel: any) => void,
  ) => Promise<void>;
  hasMultiple?: boolean;
  dealwithData?: (data: any) => any;
  defaultLoading?: boolean;
}) {
  const [loading, setLoading] = useState(defaultLoading);
  const cancelFunc = useRef<any>(null);

  const [basicOptions, setBasicOptions] = useState<Array<any>>([]);

  function dealwithSearchContent(searchContent?: string) {
    if (searchContent && searchContent.includes(',') && hasMultiple) {
      return {
        [multipleKey]: searchContent.split(','),
      };
    }

    return {
      [singleKey]: searchContent || '',
    };
  }

  const getFilterList = (searchContent?: string, otherParams: any = {}) => {
    if (gameInfo?.edition_unified_id) {
      loading === false && setLoading(true);
      if (cancelFunc.current !== null) {
        cancelFunc.current();
        cancelFunc.current = null;
        setTimeout(() => {
          setLoading(true);
        }, 1);
      }

      const contentInfo = dealwithSearchContent(searchContent);
      const realParams = {
        ...gameInfo,
        ...(timeParams || {}),
        ...contentInfo,
        ...params,
        ...otherParams,
      };

      requestFunc(realParams, (cancel: any) => {
        cancelFunc.current = cancel;
      })
        .then((data: any) => {
          setBasicOptions(dealwithData(data) || []);
        }).catch(() => {
          setBasicOptions([]);
        }).finally(() => {
          setLoading(false);
        });
    }
  };

  const clearOptions = () => {
    setBasicOptions([]);
  };

  const changeBasicOptions = (data: Array<any>) => {
    if (Array.isArray(data)) {
      setBasicOptions(data);
    }
  };

  const debounceGetFilterList = useMemo(() => {
    return debounce(getFilterList, 500);
  }, [timeParams]);

  return {
    loading,
    basicOptions,
    getFilterList,
    clearOptions,
    debounceGetFilterList,
    setLoading,
    changeBasicOptions,
  };
}
